import React from "react";
import { withStyles } from "@material-ui/core";
import SupplementationFilterContainer from "../shared/supplementationFilter/supplementationFilterContainer";
import SupplementationNotFound from "../shared/supplementationNotFound";
import SupplementationListHeader from "./components/supplementationListHeader";
import SupplementationListTable from "./components/supplementationListTable";
import { Trans } from "adapters/i18n";

const SupplementationListPage = ({
  classes,
  filter,
  getSupplementations,
  deleteSupplementation,
  isDeletedSupplementationsPage,
  goToSupplementationEdit = () => { },
  goToViewSupplementation = () => { },
  goToDeletedSupplementationsPage = () => { },
  goBack = () => { },
}) => {
  const isFilterEmpty =
    filter &&
    !filter.formula.selected.length &&
    !filter.pasture.selected.length &&
    !filter.user.selected.length &&
    !filter.beginDate.value &&
    !filter.endDate.value;

  const notExistSupplementationsText = (
    <Trans
      i18nKey="supplementation:not-exist-supplementations-text"
      components={{ accent: <span className={classes.textAccent} /> }}
    />
  );

  const notExistSupplementationsDeletedText = (
    <Trans
      i18nKey="supplementation:not-exist-supplementations-deleted-text"
    />
  );

  const notFoundSupplementationsText = (
    <Trans i18nKey="common:not-found-text" />
  );

  const renderEmptyMessage = () => {
    if (isFilterEmpty) {
      return isDeletedSupplementationsPage
        ? notExistSupplementationsDeletedText
        : notExistSupplementationsText;
    } else {
      return notFoundSupplementationsText;
    }
  };

  return (
    <div className={classes.supplementationListPage} id="SupplementationList">
      <div>
        <SupplementationListHeader
          isDeletedSupplementationsPage={isDeletedSupplementationsPage}
          onGoBack={goBack}
        />
        <SupplementationFilterContainer
          filter={filter}
          isDeletedSupplementationsPage={isDeletedSupplementationsPage}
          goToDeletedSupplementationsPage={goToDeletedSupplementationsPage}
        />
        <div className={classes.pageContentWrapper}>
          <SupplementationListTable
            getSupplementations={getSupplementations}
            deleteSupplementation={deleteSupplementation}
            removeActionsColumn={isDeletedSupplementationsPage}
            goToSupplementationEdit={goToSupplementationEdit}
            goToViewSupplementation={goToViewSupplementation}
            NotFoundComponent={() => (
              <SupplementationNotFound notFoundText={renderEmptyMessage()} />
            )}
          />
        </div>
      </div>
    </div>
  );
};

const styles = (theme) => {
  return {
    supplementationListPage: {
      width: "100%",
      minHeight: "80vh",
      overflowX: "auto",
      padding: "5px 40px",
      zIndex: -1,
      bottom: 0,
    },
    pageContentWrapper: {
      width: "100%",
      marginTop: "40px",
    },
    textAccent: {
      color: theme.palette.primary.main,
    },
  };
};

export default withStyles(styles)(SupplementationListPage);
